import sortBy from 'lodash/sortBy'
import uniqBy from 'lodash/uniqBy'
import uniqueId from 'lodash/uniqueId'

const setTags = (state, rawTags) => {
  const tags = sortBy(uniqBy(rawTags, 'name'), 'name').map(tag => ({
    id: uniqueId(),
    ...tag
  }))

  Object.assign(state, { tags })
}

const setChannel = (state, doc) => {
  const channel = { id: doc.id, ...doc.data() }
  Object.assign(state, { channel })
}

export default {
  setTags,
  setChannel
}
